import { render, staticRenderFns } from "./VCart.vue?vue&type=template&id=57e2b304"
import script from "./VCart.vue?vue&type=script&lang=js"
export * from "./VCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports